import { StateEffect, StateField } from "@codemirror/state";

const addEffectListenerEffect = StateEffect.define();
const removeEffectListenerEffect = StateEffect.define();

export function effectListeners() {
    return [effectListenersField];
}

const effectListenersField = StateField.define({
    create() {
        return [];
    },
    update(value, transaction) {
        let nextValue = value.slice();

        for (const effect of transaction.effects) {
            if (effect.is(addEffectListenerEffect)) {
                nextValue.push(effect.value);
            }

            if (effect.is(removeEffectListenerEffect)) {
                nextValue = nextValue.filter(
                    (listener) =>
                        !(listener.effect === effect.value.effect && listener.callback === effect.value.callback),
                );
            }

            for (let index = 0; index < nextValue.length; index += 1) {
                const listener = nextValue[index];
                if (effect.is(listener.effect)) {
                    window.setTimeout(() => listener.callback(effect.value));
                    if (listener.options?.once) {
                        nextValue.splice(index, 1);
                        index -= 1;
                    }
                }
            }
        }

        return nextValue;
    },
});

export function addEffectListener(view, effect, callback, options) {
    view.dispatch({
        effects: addEffectListenerEffect.of({ effect, callback, options }),
    });
}

export function removeEffectListener(view, effect, callback) {
    view.dispatch({
        effects: removeEffectListenerEffect.of({ effect, callback }),
    });
}
